import BaseService from '../../base/base_service';
import Model from './menu_model';
import _ from '../../utils/underscore';


class MenuService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'MenuService';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;

    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._model = Model.create(params);
    }

    /**
     *
     * @returns {Array}
     * @public
     */

    getJSON() {
        let menuLength = this._model.getMenuStructure().length;
        if (0 === menuLength) {
            this.logger.error('Could not get menu structure to build valid json menu!');
            return new Promise(resolve => {
                resolve([]);
            });
        }
        return this._addVisibleMenu();
    }

    _isAuthorized() {
        return this.serviceFactory.oAuth2Service().isAuthorized() ? 1 : 0;
    }

    _addVisibleMenu() {
        const menuItems = this._model.getMenuStructure();

        return Promise.all(menuItems.map(item => item.display(this._isAuthorized())))
            .then(() => menuItems.filter(item => item.visible !== false))
            .then(_menuItems => _menuItems.map(item => {
                item.translation = this.serviceFactory.languageService().translation(item.title);
                return item;
            }));
    }

    /**
     *
     * @returns {string}
     */
    getHTML() {
            return this.getJSON()
                .then(menus => {
                    let menuHTMLArray = [];
                    menuHTMLArray = menus.map((menuItem) => {
                        let clickHandler = menuItem.preAction ? menuItem.preAction + ';' : '';
                        clickHandler += menuItem.link ? menuItem.link : '';
                        return '<li'
                            + this._injectDataAttribute('id', menuItem.id)
                            + '><a href="javascript:;" onclick="' + clickHandler +'">'
                            + menuItem.translation + '</a><span'
                            + this._injectDataAttribute('class', menuItem.class)
                            + '></span></li>';
                    });
                    return '<ul class="menu">' + menuHTMLArray.join('') + '</ul>';
        });
    }

    /**
     *
     * @param attribute
     * @param value
     * @returns {*}
     * @private
     */
    _injectDataAttribute(attribute, value) {
        return !value ? '' :  ' ' + attribute + '="' + value + '"';
    }


    /**
     * Execute current menu action
     *
     * @param menuId
     */
    executeAction(menuId) {
        this.getJSON().then(menu => {
            let currentMenu = menu.find((menuItem) => {
                return menuItem.id === menuId;
            });
            if (currentMenu) {
                if (_.isFunction(currentMenu.analyticEvent)) {
                    currentMenu.analyticEvent.call();
                }
                if (_.isFunction(currentMenu.action)) {
                    currentMenu.action.call();
                }
            }
        });
    }
}


export default MenuService;